import React, { useState, useEffect } from 'react';
import { Phone, Award, Menu, X, Download, GraduationCap, ChevronRight } from 'lucide-react';

export default function Navbar({ onOpenBrochure, onApplyClick }) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header style={{ position: 'sticky', top: 0, zIndex: 100, width: '100%' }}>
      {/* Top Bar */}
      <div className="nav-top-bar" style={{
        backgroundColor: '#07131E',
        color: '#94A3B8',
        fontSize: '0.8rem',
        padding: '0.4rem 0',
        borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
        width: '100%'
      }}>
        <div className="container nav-top-container" style={{
          display: 'flex',
          justify: 'space-between',
          alignItems: 'center',
          gap: '0.5rem'
        }}>
          <div className="nav-top-left" style={{ display: 'flex', alignItems: 'center', gap: '1.25rem', flexWrap: 'wrap' }}>
            <span className="nav-top-badge" style={{ display: 'inline-flex', alignItems: 'center', gap: '0.35rem', color: '#FEF08A', fontWeight: 600, whiteSpace: 'nowrap' }}>
              <Award size={14} color="#D4AF37" /> NAAC A+ Grade | UGC Entitled
            </span>
            <span className="nav-top-badge" style={{ display: 'inline-flex', alignItems: 'center', gap: '0.35rem', whiteSpace: 'nowrap' }}>
              <GraduationCap size={14} color="#38BDF8" /> Category-1 Autonomy Granted
            </span>
          </div>

          <div className="nav-top-right" style={{ display: 'flex', alignItems: 'center', gap: '1.25rem', flexShrink: 0 }}>
            <a href="tel:+917631900600" className="nav-top-badge" style={{ color: '#F1F5F9', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: '0.35rem', fontWeight: 500, whiteSpace: 'nowrap' }}>
              <Phone size={13} color="#D4AF37" /> Helpline: +91 7631 900 600
            </a>
          </div>
        </div>
      </div>

      {/* Main Navbar */}
      <nav style={{
        backgroundColor: isScrolled ? 'rgba(15, 37, 55, 0.98)' : '#0F2537',
        backdropFilter: 'blur(12px)',
        borderBottom: '1px solid rgba(212, 175, 55, 0.25)',
        boxShadow: isScrolled ? '0 10px 30px rgba(0, 0, 0, 0.25)' : 'none',
        transition: 'all 0.3s ease',
        width: '100%'
      }}>
        <div className="container nav-main-container" style={{
          display: 'flex',
          justify: 'space-between',
          alignItems: 'center',
          height: '76px'
        }}>
          
          {/* Brand Logo */}
          <a href="#hero" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', flexShrink: 0 }}>
            <div className="nav-logo-box" style={{
              height: '48px',
              backgroundColor: '#FFFFFF',
              borderRadius: '10px',
              padding: '4px 12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 4px 12px rgba(212, 175, 55, 0.2)'
            }}>
              <img 
                src="/uploads/logo.png" 
                alt="CHRIST (Deemed to be University)" 
                className="nav-logo-img"
                style={{ height: '40px', objectFit: 'contain' }}
              />
            </div>
          </a>

          {/* Desktop Navigation Links */}
          <div className="desktop-menu" style={{ display: 'flex', alignItems: 'center', gap: '1.75rem', justifyContent: 'center', flexGrow: 1, margin: '0 1.5rem' }}>
            <a href="#programs" style={{ color: '#F1F5F9', textDecoration: 'none', fontWeight: 600, fontSize: '0.92rem', transition: 'color 0.2s', whiteSpace: 'nowrap' }}>
              Programs
            </a>
            <a href="#why-christ" style={{ color: '#F1F5F9', textDecoration: 'none', fontWeight: 600, fontSize: '0.92rem', transition: 'color 0.2s', whiteSpace: 'nowrap' }}>
              Why Christ
            </a>
            <a href="#calculator" style={{ color: '#F1F5F9', textDecoration: 'none', fontWeight: 600, fontSize: '0.92rem', transition: 'color 0.2s', whiteSpace: 'nowrap' }}>
              Fee & EMI
            </a>
            <a href="#placements" style={{ color: '#F1F5F9', textDecoration: 'none', fontWeight: 600, fontSize: '0.92rem', transition: 'color 0.2s', whiteSpace: 'nowrap' }}>
              Placements
            </a>
            <a href="#faqs" style={{ color: '#F1F5F9', textDecoration: 'none', fontWeight: 600, fontSize: '0.92rem', transition: 'color 0.2s', whiteSpace: 'nowrap' }}>
              FAQs
            </a>
          </div>

          {/* Action CTAs */}
          <div className="nav-action-ctas" style={{ display: 'flex', alignItems: 'center', gap: '0.85rem', flexShrink: 0, marginLeft: 'auto' }}>
            <button 
              onClick={onOpenBrochure} 
              className="btn-secondary nav-brochure-btn"
              style={{ padding: '0.6rem 1.1rem', fontSize: '0.85rem', whiteSpace: 'nowrap' }}
            >
              <Download size={15} color="#D4AF37" /> Brochure
            </button>
            <button 
              onClick={onApplyClick} 
              className="btn-primary nav-apply-btn"
              style={{ padding: '0.65rem 1.35rem', fontSize: '0.88rem', whiteSpace: 'nowrap' }}
            >
              Apply Now <ChevronRight size={16} />
            </button>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              style={{
                background: 'transparent',
                border: 'none',
                color: '#FFFFFF',
                cursor: 'pointer',
                padding: '0.5rem',
                display: 'none',
                alignItems: 'center',
                justifyContent: 'center'
              }}
              className="mobile-toggle"
              aria-label="Toggle Menu"
            >
              {mobileMenuOpen ? <X size={26} /> : <Menu size={26} />}
            </button>
          </div>

        </div>

        {/* Mobile Navigation Drawer */}
        {mobileMenuOpen && (
          <div style={{
            backgroundColor: '#07131E',
            borderTop: '1px solid rgba(255, 255, 255, 0.1)',
            padding: '1.25rem 1.5rem',
            display: 'flex',
            flexDirection: 'column',
            gap: '1.1rem'
          }}>
            <a href="#programs" onClick={() => setMobileMenuOpen(false)} style={{ color: '#FFFFFF', textDecoration: 'none', fontSize: '1rem', fontWeight: 600 }}>Programs</a>
            <a href="#why-christ" onClick={() => setMobileMenuOpen(false)} style={{ color: '#FFFFFF', textDecoration: 'none', fontSize: '1rem', fontWeight: 600 }}>Why Christ Online</a>
            <a href="#calculator" onClick={() => setMobileMenuOpen(false)} style={{ color: '#FFFFFF', textDecoration: 'none', fontSize: '1rem', fontWeight: 600 }}>Fee & EMI Calculator</a>
            <a href="#placements" onClick={() => setMobileMenuOpen(false)} style={{ color: '#FFFFFF', textDecoration: 'none', fontSize: '1rem', fontWeight: 600 }}>Placement Support</a>
            <a href="#faqs" onClick={() => setMobileMenuOpen(false)} style={{ color: '#FFFFFF', textDecoration: 'none', fontSize: '1rem', fontWeight: 600 }}>FAQs</a>
            
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem', marginTop: '0.5rem', paddingTop: '0.75rem', borderTop: '1px solid rgba(255,255,255,0.08)' }}>
              <button 
                onClick={() => { setMobileMenuOpen(false); onOpenBrochure(); }} 
                className="btn-secondary"
                style={{ width: '100%', padding: '0.75rem', fontSize: '0.9rem' }}
              >
                <Download size={16} color="#D4AF37" /> Download Brochure
              </button>
              <button 
                onClick={() => { setMobileMenuOpen(false); onApplyClick(); }} 
                className="btn-primary"
                style={{ width: '100%', padding: '0.75rem', fontSize: '0.9rem' }}
              >
                Apply Now <ChevronRight size={16} />
              </button>
            </div>
          </div>
        )}
      </nav>
      
      {/* Styles for Responsive Header */}
      <style>{`
        @media (max-width: 1024px) {
          .desktop-menu { gap: 1rem !important; margin: 0 0.75rem !important; }
          .desktop-menu a { font-size: 0.85rem !important; }
        }

        @media (max-width: 900px) {
          .desktop-menu { display: none !important; }
          .mobile-toggle { display: flex !important; }
          .nav-brochure-btn { display: none !important; }
          .nav-action-ctas { margin-left: auto !important; }
        }

        @media (max-width: 768px) {
          .nav-top-bar {
            padding: 0.35rem 0 !important;
          }
          .nav-top-container {
            flex-direction: column !important;
            justify-content: center !important;
            align-items: center !important;
            text-align: center !important;
            gap: 0.25rem !important;
          }
          .nav-top-left {
            flex-direction: column !important;
            justify-content: center !important;
            align-items: center !important;
            gap: 0.2rem !important;
            width: 100% !important;
          }
          .nav-top-right {
            justify-content: center !important;
            width: 100% !important;
          }
          .nav-top-badge {
            font-size: 0.73rem !important;
            white-space: nowrap !important;
            justify-content: center !important;
          }
          .nav-main-container {
            height: 60px !important;
            padding: 0 1rem !important;
          }
          .nav-logo-box {
            height: 38px !important;
            padding: 3px 8px !important;
            border-radius: 8px !important;
          }
          .nav-logo-img {
            height: 30px !important;
          }
          .nav-action-ctas {
            gap: 0.5rem !important;
            margin-left: auto !important;
          }
        }

        @media (max-width: 520px) {
          .nav-apply-btn {
            display: none !important;
          }
          .nav-logo-box {
            height: 36px !important;
            padding: 3px 8px !important;
          }
          .nav-logo-img {
            height: 28px !important;
          }
        }
      `}</style>
    </header>
  );
}

